import React, {useEffect, useState} from "react";
import {Button, CustomInput} from "../../index";
import styles from "./styles.module.css"
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../../store";
import {Box} from "@mui/material";
import {setUser} from "../../../store/reducer";
import {useTranslation} from "react-i18next";
import {useGetProfilesByIdQuery, useUpdateProfileMutation} from "../../../api/modules";

interface IProps {
    id?: number | string | null
}

const ProfileName: React.FC<IProps> = (props) => {
    const {id} = props
    const dispatch: AppDispatch = useDispatch()
    const {t} = useTranslation("translations");
    const [value, setValue] = useState("");
    const [updateProfile, {isLoading}] = useUpdateProfileMutation()
    const {data: profile} = useGetProfilesByIdQuery(id as string)

    useEffect(() => {
        profile && setValue(profile?.name)
    }, [profile]);

    const handleUpdate = async () => {
        if (!id) return;
        if (profile?.name === value) return;
        try {
            const res = await updateProfile({id, body: {name: value}}).unwrap();
            if (res) dispatch(setUser(res));
        } catch (err) {
            console.error("Profile update error:", err);
        }
    };
    return (
        <Box className={styles.content}>
            <CustomInput
                name={"name"}
                value={value}
                onChange={(e) => setValue(e.target.value)}
            />
              <Button sx={{maxWidth: "420px"}} fullWidth color="secondary" variant="contained" onClick={handleUpdate}
                      isLoading={isLoading}>
                  {t("Buttons.saveName")}
              </Button>
        </Box>
    );
};

export default ProfileName;
